import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import "../styles/brands.css";
import { useCart } from "../context/cart";
import { Link } from "react-router-dom";
import { AiOutlineEye } from "react-icons/ai";
import { MdAirlineSeatReclineExtra } from "react-icons/md";
import { BsFuelPumpFill } from "react-icons/bs";
import { TbEngine, TbStars } from "react-icons/tb";
import toast from "react-hot-toast";
import { ColorRing } from "react-loader-spinner";
import { server } from "../server";
import { GoHeart } from "react-icons/go";
import { Helmet } from "react-helmet";

const CarInBrand = () => {
  const params = useParams();
  const [brand, setBrand] = useState({
    name: "",
    image: [{ url: "" }],
    carInvoleInThisBrand: [],
    description: "",
    slug: "",
  });
  const [cart, setcart] = useCart();
  const [loading, setLoading] = useState(true);

  const getCar = useCallback(async () => {
    try {
      const { data } = await axios.get(
        `${server}/api/brand/getBrandBtId-brand/${params.slug}`,
      );
      setBrand(data.brand);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(true);
    }
  }, [params.slug]);

  const notify = () => toast.success("Added to favorites successfully");

  useEffect(() => {
    getCar();
    window.scrollTo(0, 0);
  }, [getCar]);

  // Generate structured data for SEO
  const generateStructuredData = () => {
    return {
      "@context": "https://schema.org",
      "@type": "Brand",
      name: brand.name,
      description:
        brand.description ||
        `${brand.name} cars available in Kenya at Classic Motors KE`,
      url: window.location.href,
      logo: brand.image?.[0]?.url || "",
      sameAs: [
        "https://www.facebook.com/classicmotorske",
        "https://www.instagram.com/classicmotorske",
      ],
    };
  };

  // Breadcrumb path
  const breadcrumbPath = [
    { name: "Home", path: "/" },
    { name: "Brands", path: "/brands" },
    { name: brand.name || "Brand", path: "" },
  ];

  return (
    <div style={{ marginTop: "70px" }}>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>{`${brand.name} Cars in Kenya | Classic Motors KE - Mombasa Car Dealer`}</title>
        <meta
          name="description"
          content={`Browse our collection of ${brand.name} vehicles in Mombasa, Kenya. New, foreign, and locally used ${brand.name} cars available at competitive prices.`}
        />
        <meta
          name="keywords"
          content={`${brand.name} cars Kenya, ${brand.name} dealer Mombasa, used ${brand.name} vehicles, buy ${brand.name} in Kenya`}
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href={`https://classicmotorske.com/brand/${brand.slug}`}
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://classicmotorske.com/brand/${brand.slug}`}
        />
        <meta
          property="og:title"
          content={`${brand.name} Cars in Kenya | Classic Motors KE`}
        />
        <meta
          property="og:description"
          content={`Browse our collection of ${brand.name} vehicles in Mombasa, Kenya. New, foreign, and locally used ${brand.name} cars available.`}
        />
        <meta property="og:image" content={brand.image?.[0]?.url || ""} />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content={`https://classicmotorske.com/brand/${brand.slug}`}
        />
        <meta
          property="twitter:title"
          content={`${brand.name} Cars in Kenya | Classic Motors KE`}
        />
        <meta
          property="twitter:description"
          content={`Browse our collection of ${brand.name} vehicles in Mombasa, Kenya. New, foreign, and locally used ${brand.name} cars available.`}
        />
        <meta property="twitter:image" content={brand.image?.[0]?.url || ""} />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(generateStructuredData())}
        </script>
      </Helmet>

      {/* Breadcrumb Navigation */}
      <nav aria-label="breadcrumb" className="container mt-4">
        <ol className="breadcrumb">
          {breadcrumbPath.map((item, index) => (
            <li
              key={index}
              className={`breadcrumb-item ${
                index === breadcrumbPath.length - 1 ? "active" : ""
              }`}
            >
              {item.path ? (
                <Link to={item.path}>{item.name}</Link>
              ) : (
                <span>{item.name}</span>
              )}
              {index < breadcrumbPath.length - 1 && (
                <span className="mx-2"> </span>
              )}
            </li>
          ))}
        </ol>
      </nav>

      <section
        id="brands"
        className="brand_wrapper"
        style={{ marginTop: "20px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-4">
              <h1 className="brand_title">{brand.name} Vehicles in Kenya</h1>
              {brand.description && (
                <p className="lead mt-3">{brand.description}</p>
              )}
            </div>
          </div>
          {loading ? (
            <div className="h-100 d-flex align-items-center justify-content-center">
              <ColorRing
                visible={true}
                colors={[
                  "#000435",
                  "rgb(14 165 233)",
                  "rgb(243 244 246)",
                  "#000435",
                  "rgb(14 165 233)",
                ]}
              />
            </div>
          ) : (
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 col-sm-8 showcase_card">
                <img
                  decoding="async"
                  src={brand.image?.[0]?.url}
                  alt={`${brand.name} logo`}
                  className="mb-4 img-fluid"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "200px",
                    objectFit: "contain",
                  }}
                  loading="lazy"
                />
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Available Cars Section */}
      <div className="container">
        <div className="row" style={{ marginBottom: "100px" }}>
          <div className="col-12 text-center mb-5">
            <h2 className="brand_title">
              Available {brand.name} Inventory (
              {brand.carInvoleInThisBrand?.length || 0} Vehicles)
            </h2>
          </div>
          {Array.isArray(brand.carInvoleInThisBrand) &&
          brand.carInvoleInThisBrand.length > 0 ? (
            brand.carInvoleInThisBrand.map((p) => (
              <div className="col-md-6 col-lg-3 mb-4" key={p._id}>
                <div className="card h-100">
                  <div className="d-flex justify-content-between p-3">
                    <span className="badge bg-primary">
                      {p.condition || "New"}
                    </span>
                    <span className="badge bg-success">{p.yom || "N/A"}</span>
                  </div>
                  <Link
                    to={`/car/${p.slug}`}
                    className="text-center"
                    aria-label={`View ${p.name} details`}
                  >
                    <img
                      src={p.documents?.[0]?.url}
                      alt={`${p.name} ${p.yom} for sale in Kenya`}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "130px",
                        objectFit: "contain",
                      }}
                      className="border rounded"
                      loading="lazy"
                    />
                  </Link>
                  <div className="card-body d-flex flex-column">
                    <h3 className="text-center mb-1 h5">
                      <Link
                        to={`/car/${p.slug}`}
                        className="text-decoration-none"
                      >
                        {p.name}
                      </Link>
                    </h3>
                    <p className="text-muted small">
                      {p.description.length > 60
                        ? `${p.description.substring(0, 60)}...`
                        : p.description}
                    </p>
                    <div className="mt-auto">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="h6 mb-0">
                          KES {Number(p.price).toLocaleString()}
                        </span>
                        <small className="text-muted">Negotiable</small>
                      </div>
                      <div className="d-flex justify-content-between small mb-3">
                        <span>
                          <TbEngine size={18} color="#8a2be2" /> {p.engineSize}
                          cc
                        </span>
                        <span>
                          <BsFuelPumpFill color="#8a2be2" /> {p.fuelType}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between small mb-3">
                        <span>
                          <TbStars color="#8a2be2" /> {p.safetyrating}★
                        </span>
                        <span>
                          <MdAirlineSeatReclineExtra color="#8a2be2" />{" "}
                          {p.seater} Seats
                        </span>
                      </div>
                      <div className="d-flex justify-content-center gap-2">
                        <Link
                          className="btn btn-sm"
                          style={{
                            backgroundColor: "blueviolet",
                            color: "white",
                          }}
                          to={`/car/${p.slug}`}
                          aria-label={`View ${p.name} details`}
                        >
                          <AiOutlineEye size={16} className="me-1" /> Details
                        </Link>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => {
                            setcart([...cart, p]);
                            localStorage.setItem(
                              "cart",
                              JSON.stringify([...cart, p]),
                            );
                            notify();
                          }}
                          aria-label={`Save ${p.name} to favorites`}
                        >
                          <GoHeart size={16} className="me-1" /> Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-5">
              <h4 className="mb-4">
                {loading
                  ? "Loading..."
                  : `Currently no ${brand.name} vehicles in stock`}
              </h4>
              <Link to="/cars" className="btn btn-primary">
                Browse All Vehicles
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CarInBrand;
